
const homeStyle = theme => ({
    gridContainer: {
        height: "60vh",
        position: "relative"
    },
    titleGridItem: {
        background: "red"
    },
    title: {
        color: "white",
        fontWeight: "500"
    },
    loginGridItem: {
        backgroundColor: "#4a4d4e",
        lineHeight: "4em",
        color: "white",
        width: "100%",
        position: "absolute",
        bottom: 0,
        left: "50%",
        transform: "translate(-50% , -50%)",
        webkitTransform: "translate(-50%, -50%)"
    },
    loginLink: {
        color: "white",
        textDecoration: "underline",
        "&:hover,&:focus": {
            color: "white",
            fontWeight: "500",
            textDecoration: "underline"
        }
    }
});

export default homeStyle;
